export const AUDIOMATCHING_FILES_DIRECTORY = '../assets/audio-matching/';
